module.exports = __webpack_public_path__ + "static/media/hillshade-desktop.d14a0661.png";